import { render, staticRenderFns } from "./LicenseItem.vue?vue&type=template&id=1552a34d&scoped=true&"
import script from "./LicenseItem.vue?vue&type=script&lang=js&"
export * from "./LicenseItem.vue?vue&type=script&lang=js&"
import style0 from "./LicenseItem.vue?vue&type=style&index=0&id=1552a34d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552a34d",
  null
  
)

export default component.exports